import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import CGMStatusCardTemplate from "./CGMStatusCardTemplate";
import Button from "src/components/app/Button";

import CGMExpiredStatus from "src/assets/images/cgm/status/cgm-expired-status.png";
import { POST_MESSAGE_EVENTS } from "src/constants/common";
import { sendMessageToParent } from "src/helpers/common";

interface CGMErrorStatusCardProps {
  color: string;
  bgColor?: string;
  label: string;
  errorId?: string;
}

const CGMErrorStatusCard: React.FC<CGMErrorStatusCardProps> = ({
  color,
  bgColor,
  label,
  errorId,
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const supportProgramKey = params["support-program-key"] ?? "";

  return (
    <CGMStatusCardTemplate
      image={CGMExpiredStatus}
      color={color}
      bgColor={bgColor}
      label={errorId ?? "Error"}
      description={
        <div>
          <p className="text-xs mb-4">
            We're sorry to say that you're experiencing issues with your CGM.
            Please contact our support team and we'll get you back on track.
          </p>
          <Button
            variant="contained"
            color="primary"
            rounded="full"
            fullWidth
            onClick={() => navigate(`/app/${supportProgramKey}/cgm-need-help`)}
          >
            Contact Support
          </Button>
        </div>
      }
      // bottomContent={
      //   <p className="text-sm text-gray-500 text-center">
      //     Need a new CGM or sensors?{" "}
      //     <span
      //       className="text-[var(--app-primary)] font-semibold underline cursor-pointer"
      //       onClick={() => {
      //         const data = {
      //           title: "Buy CGM",
      //           link: "https://shop.goodflip.in/products/goodflip-smart-cgm-device",
      //         };
      //         sendMessageToParent(POST_MESSAGE_EVENTS.OPEN_EXTERNAL_LINK, data);
      //       }}
      //     >
      //       Buy CGM
      //     </span>
      //   </p>
      // }
    />
  );
};

export default CGMErrorStatusCard;
